import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import {
  CONSUMER_CREDIT_ROUTE,
  CONTACT_US_ROUTE,
  CONTACT_US_SINGLE_ROUTE,
  SECTION_ROUTE,
  HOME_ROUTE,
  OFFICES_ROUTE,
  OFFICES_SINGLE_ROUTE,
  INSTALLMENT_PAYMENT_ROUTE,
  INSTALLMENT_PAYMENT_ROUTE_CONFIRMATION,
  RATES_AND_FEES_SINGLE_ROUTE,
  RATES_AND_FEES_ROUTE,
  PORTABILITY_SINGLE_ROUTE,
  PORTABILITY_ROUTE,
  NORMATIVE_INFORMATION_AND_LEGAL_BASES_SINGLE_ROUTE,
  NORMATIVE_INFORMATION_AND_LEGAL_BASES_ROUTE,
  FAQS_ROUTE,
  FAQS_SINGLE_ROUTE,
} from '@common/constants/routes.constants';
import { TAG_TITLES } from '@common/constants/tag-titles.constants';
import { BREADCRUMB_TEXT } from '@common/constants/section-titles.constants';
import { BaseLayoutComponent } from '@components/base-layout/base-layout.component';
import { BaseFormLayoutComponent } from '@components/base-form-layout/base-form-layout.component';

const routes: Routes = [
  {
    path: HOME_ROUTE,
    loadChildren: () => import('./pages/home/home.module').then((m) => m.HomePageModule),
    data: { title: TAG_TITLES[HOME_ROUTE], breadcrumb: BREADCRUMB_TEXT[HOME_ROUTE] }
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: HOME_ROUTE,
    data: { breadcrumb: BREADCRUMB_TEXT[HOME_ROUTE] }
  },
  {
    path: CONSUMER_CREDIT_ROUTE,
    loadChildren: () => import('./pages/consumer-credit/consumer-credit.module').then((m) => m.ConsumerCreditPageModule),
    data: { title: TAG_TITLES[CONSUMER_CREDIT_ROUTE], breadcrumb: BREADCRUMB_TEXT[CONSUMER_CREDIT_ROUTE] }
  },
  {
    path: SECTION_ROUTE,
    component: BaseLayoutComponent,
    data: { breadcrumb: { skip: true } },
    children: [
      {
        path: CONTACT_US_SINGLE_ROUTE,
        loadChildren: () => import('./pages/contact-us/contact-us.module').then((m) => m.ContactUsPageModule ),
        data: { title: TAG_TITLES[CONTACT_US_ROUTE], breadcrumb: BREADCRUMB_TEXT[CONTACT_US_ROUTE] }
      }
    ]
  },
  {
    path: '',
    component: BaseFormLayoutComponent,
    children: [
      {
        path: INSTALLMENT_PAYMENT_ROUTE,
        loadChildren: () => import('./pages/installment-payment/installment-payment.module').then((m) => m.InstallmentPaymentPageModule),
        data: { title: TAG_TITLES[INSTALLMENT_PAYMENT_ROUTE], breadcrumb: BREADCRUMB_TEXT[INSTALLMENT_PAYMENT_ROUTE] }
      },
      {
        path: INSTALLMENT_PAYMENT_ROUTE_CONFIRMATION,
        loadChildren: () => import('./pages/installment-payment/installment-payment.module').then((m) => m.InstallmentPaymentPageModule),
        data: { title: TAG_TITLES[INSTALLMENT_PAYMENT_ROUTE], breadcrumb: BREADCRUMB_TEXT[INSTALLMENT_PAYMENT_ROUTE] }
      },
    ],
  },
  {
    path: CONTACT_US_ROUTE,
    component: BaseLayoutComponent,
    data: { breadcrumb: BREADCRUMB_TEXT[CONTACT_US_ROUTE] },
    children: [
      {
        path: OFFICES_SINGLE_ROUTE,
        loadChildren: () => import('./pages/offices/offices.module').then((m) => m.OfficesPageModule ),
        data: { title: TAG_TITLES[OFFICES_ROUTE], breadcrumb: BREADCRUMB_TEXT[OFFICES_ROUTE] }
      },
      {
        path: RATES_AND_FEES_SINGLE_ROUTE,
        loadChildren: () => import('./pages/rates-and-fees/rates-and-fees.module').then((m) => m.RatesAndFeesPageModule),
        data: { title: TAG_TITLES[RATES_AND_FEES_ROUTE], breadcrumb: BREADCRUMB_TEXT[RATES_AND_FEES_ROUTE] }
      },
      {
        path: PORTABILITY_SINGLE_ROUTE,
        loadChildren: () => import('./pages/portability/portability.module').then((m) => m.PortabilityPageModule ),
        data: { title: TAG_TITLES[PORTABILITY_ROUTE], breadcrumb: BREADCRUMB_TEXT[PORTABILITY_ROUTE] }
      },
      {
        path: NORMATIVE_INFORMATION_AND_LEGAL_BASES_SINGLE_ROUTE,
        loadChildren:
          () => import('./pages/normative-information-and-legal-bases/normative-information-and-legal-bases.module')
          .then((m) => m.NormativeInformationAndLegalBasesPageModule),
        data:
        {
          title: TAG_TITLES[NORMATIVE_INFORMATION_AND_LEGAL_BASES_ROUTE],
          breadcrumb: BREADCRUMB_TEXT[NORMATIVE_INFORMATION_AND_LEGAL_BASES_ROUTE]
        }
      },
      {
        path: FAQS_SINGLE_ROUTE,
        loadChildren:
        () => import('./pages/faqs/faqs.module').then((m) => m.FaqsPageModule),
        data: { title: TAG_TITLES[FAQS_ROUTE], breadcrumb: BREADCRUMB_TEXT[FAQS_ROUTE] }
      },
    ]
  },
  {
    path: '**',
    redirectTo: HOME_ROUTE,
  },
  {
    path: 'rates-and-fees',
    loadChildren: () => import('./pages/rates-and-fees/rates-and-fees.module').then( (m) => m.RatesAndFeesPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy', initialNavigation: 'enabled' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
